export default __webpack_public_path__ + "static/media/logo_vitality_mega_menu.1bae7b1a.svg";